import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import { getTimestamp } from 'automation-ui-log-events/records/LogEvent/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const LogEventTimestamp = ({
  logEvent
}) => {
  const timestamp = getTimestamp(logEvent);
  return /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
    value: timestamp,
    format: "lll z"
  });
};
export default LogEventTimestamp;